import { FC, ReactNode } from 'react';
import { Box, Divider } from '@mui/material';

type ApplicationFormLayoutProps = {
  sidebar: ReactNode;
  form: ReactNode;
};

/** Responsive two-column layout for create/edit application pages (sidebar + form). */
const ApplicationFormLayout: FC<ApplicationFormLayoutProps> = ({ sidebar, form }) => (
  <Box
    m={{ md: 3, xs: 1 }}
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', lg: 'row' },
      alignItems: { xs: 'stretch', lg: 'flex-start' },
      gap: { xs: 2, lg: 3 }
    }}
  >
    <Box
      sx={{
        width: { xs: '100%', lg: 'min(100%, 340px)' },
        flex: { xs: '0 0 auto', lg: '0 0 340px' },
        minWidth: 0
      }}
    >
      {sidebar}
    </Box>

    <Divider sx={{ display: { xs: 'block', lg: 'none' }, width: '100%' }} />
    <Divider
      orientation="vertical"
      flexItem
      sx={{ display: { xs: 'none', lg: 'block' } }}
    />

    <Box sx={{ flex: '1 1 0', minWidth: 0, width: '100%' }}>{form}</Box>
  </Box>
);

export default ApplicationFormLayout;
